import React from "react";
import avatarPath from "../Images/josue.jpg";
import { useLanguage } from "../context/LanguageContext";
import translations from "../i18n/translations";

function SplashScreen({ progress = 0, isExiting = false }) {
  const { language } = useLanguage();
  const t = translations[language];
  const roundedProgress = Math.round(progress);

  return (
    <div
      className={`fixed inset-0 z-[100] flex flex-col items-center justify-center bg-main-bg text-white transition-opacity duration-500 ease-out ${
        isExiting ? "pointer-events-none opacity-0" : "opacity-100"
      }`}
      aria-busy={!isExiting}
      aria-hidden={isExiting}
      aria-label={t.splash.loadingLabel}
    >
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-24 -left-24 h-72 w-72 rounded-full bg-coding-color/10 blur-3xl animate-pulse-soft" />
        <div className="absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-blue-500/10 blur-3xl animate-pulse-soft" />
      </div>

      <div
        className={`relative flex flex-col items-center gap-6 transition-all duration-500 ease-out ${
          isExiting ? "-translate-y-3 scale-95 opacity-0" : "translate-y-0 scale-100 opacity-100"
        }`}
      >
        <div className="relative flex h-24 w-24 items-center justify-center">
          <span className="absolute inset-0 animate-ping rounded-full border border-coding-color/50" />
          <div className="relative flex h-24 w-24 items-center justify-center overflow-hidden rounded-full border-2 border-coding-color shadow-[0_0_30px_rgba(100,255,218,0.35)]">
            <img
              src={avatarPath}
              alt="Portrait of Josue Rushanika"
              className="h-full w-full object-cover"
              width={96}
              height={96}
            />
          </div>
        </div>

        <div className="text-center">
          <p className="text-xs uppercase tracking-[0.3em] text-coding-color">
            {t.splash.portfolio}
          </p>
          <h1 className="mt-2 font-main-font text-2xl font-semibold text-header-color">
            Josue Rushanika
          </h1>
        </div>

        <div className="mt-1 flex w-56 flex-col items-center gap-2">
          <div className="h-1 w-full overflow-hidden rounded-full bg-white/10">
            <div
              className="h-full rounded-full bg-gradient-to-r from-coding-color to-blue-400 transition-[width] duration-300 ease-out"
              style={{ width: `${Math.max(progress, 4)}%` }}
            />
          </div>
          <div className="flex w-full items-center justify-between text-xs text-gray-400">
            <span>{t.splash.loadingExperience}</span>
            <span className="font-coding-font tabular-nums text-coding-color">
              {roundedProgress}%
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SplashScreen;
